import { createFormAction } from 'redux-form-saga'
export const FORM_KEY = 'ABSENT_FORM'
export const AbsentFormAction = createFormAction(FORM_KEY)
